import Image, { type ImageProps } from 'next/image';
import TrustPilotRebrand from './trust-pilot-rebrand.svg';

export const TrustPilotSvg = (props: Omit<ImageProps, 'src'>) => {
  const { alt = 'trust pilot', ...rest } = props;

  return <Image src={TrustPilotRebrand} alt={alt} {...rest} />;
};
